/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Azure vault type for restore points
*/
export enum AzureVaultType {
  RecoveryServicesVault = 'Recovery Services Vault',
  BackupVault = 'Backup Vault'
}
